/**
 * Resolves the AWS WAF JS SDK when challenge.js has loaded.
 * Returns null when the script is empty/unset or the SDK is not ready yet.
 */
export function getAwsWafIntegration() {
    if (typeof window === "undefined") {
        return null;
    }

    const integration = window.AwsWafIntegration;
    if (!integration || typeof integration.getToken !== "function") {
        return null;
    }

    return integration;
}

/**
 * Gets a WAF challenge token for the x-aws-waf-token header.
 * Returns null when the SDK is unavailable or getToken fails/times out so API
 * calls can proceed (important while Bot Control rules are in Count mode).
 */
export async function getAwsWafToken() {
    const integration = getAwsWafIntegration();
    if (!integration) {
        return null;
    }

    try {
        const token = await integration.getToken();
        return token || null;
    } catch (error) {
        // Use console.warn (not $logger): logger POSTs go through the same Axios
        // interceptor and would recurse if getToken keeps failing.
        console.warn("AWS WAF getToken failed; continuing without token", error);
        return null;
    }
}
